module.exports = __webpack_public_path__ + "static/media/youtube.70ffd1d1.png";